import * as React from "react";
import { forwardRef } from "react";
const SvgIconConversationsSnoozed3Hours = ({
  title,
  titleId,
  ...props
}, ref) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 18, height: 18, viewBox: "0 0 18 18", ref, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { d: "M13 4a9 9 0 1 0 9 9h-1.5a7.563 7.563 0 1 1-1.031-3.75H16.75v1.5H22V5.5h-1.5v2.508A8.99 8.99 0 0 0 13 4m-.75 3v6.75h5.25v-1.5h-3.75V7z", "data-name": "Path 770", transform: "translate(-4 -4)", fill: "#98a9bc" }));
const ForwardRef = forwardRef(SvgIconConversationsSnoozed3Hours);
export { ForwardRef as ReactComponent };
